export const FILTER = {
  EXPAND: "expand",
  COLLAPSE: "collapse",
  FILTERS: "filters",
  HIDE_DISCONTINUED: "hide discontinued products",
}

export const HELP_AND_FAQ = "support:help and faq"
export const SEARCH_RESULTS = "search results:technical"
export const TECHNICAL_SPECS = "technical specs"
